export default __webpack_public_path__ + "a7df427f2c6df539a78d5e33123e159b.png";